import {Component, OnInit} from '@angular/core';
import {BaseService} from '../../base.service';
import {SliderService} from '../../services/slider.service';
import {Location} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {SliderDto} from '../../dto/slider.dto';
import { ContractsService } from '../../services/contracts.service';
import { Contract } from '../../models/contract';
import { multicast } from 'rxjs/operators';
import { environment } from '../../../environments/environment.local';
import { Env } from '../../env';


@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;

  contract:Contract = {
    id: 0,
    amount: "",
    amountToReceive: "",
    creationDate: null,
    currencyCode: "",

    dayMonth: 0,
    fee: 0,
    paymentStatus: "",
    percentageFee: 0,
    status: "",

    tenantSignature: "",
    time: 0,

    division:"",
    property:"",
    tenant:"",
    owner:"",

    divisionDetail: {
      codeForPlan: "",
      creationDate: null,
      id: "",
      name: "",
    },
    propertyDetail: {
      address: "",
      creationDate: null,
      dni: null,
      fullName: "",
      id: 0,
      ownerType: "",
      propertyDetails: "",
      propertyName: "",
      razonSocial: null,
      rentFullProperty: null,
      ruc: null,
      status: "",
    },
    tenantDetail: {
      creationDate: null,
      dni: "",
      email: "",
      id: "",
      lastName: "",
      name: "",
      phoneNumber: "",
      status: false,
    },
    ownerDetail: {
      creationDate: null,
      dni: "",
      email: "",
      id: "",
      lastName: "",
      name: "",
      phoneNumber: "",
      status: false,
    }
    
  }

  constructor(
    private baseService: BaseService,
    private service: ContractsService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private env: Env
  ) {}

  ngOnInit() {
    this.titleComponent = 'Contratos';
    this.titlePanel = 'Contrato';
    this.baseService.changedComponentName(this.titleComponent);

    this.get();
  }

  get(){
    let id = this.route.snapshot.paramMap.get('id');
    this.service.get(id).subscribe( r => {
      console.log(r);
      let data:any = r;
      this.contract.id = data.id;
      this.contract.amount = data.amount;
      this.contract.amountToReceive = data.amountToReceive;
      this.contract.creationDate = data.creationDate;
      this.contract.currencyCode = data.currencyCode;

      this.contract.dayMonth = data.dayMonth;
      this.contract.fee = data.fee;
      this.contract.paymentStatus = data.paymentStatus;
      this.contract.percentageFee = data.percentageFee;
      this.contract.status = data.status;

      this.contract.tenantSignature = this.env.URL_IMAGE_BASE+data.tenantSignature+this.env.URL_IMAGE_SUFFIX;
      this.contract.time = data.time;

      this.contract.division = data.division.name;
      this.contract.property = data.property.propertyName + '  ('+data.property.propertyDetails+')';
      this.contract.tenant = data.tenant.name + '' + data.tenant.lastName;
      this.contract.owner = data.property.user.fullName;

      this.contract.propertyDetail = data.property;
      this.contract.tenantDetail = data.tenant;
      this.contract.ownerDetail = data.property.user;
      
      this.contract.divisionDetail = data.division;

    } , err => {
      console.log(err);
    });   
  }

  goBack(): void {
    this.location.back();
  }
  /*
-status
  Pendiente
  Activo
  -status de pago
  Activo("A"),
  Moroso("M"),
  Deudor("D"),
  concluido("F"),
  pendiente("P");
  */
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/contract/contract.component.ts